var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryAnalytics32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Analytics_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Analytics_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Analytics_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0002629,9.44 L24.0002629,13.94 L23.0002629,13.94 L23.0002629,10.647 L16.8542629,16.794 C16.6582629,16.989 16.3422629,16.989 16.1462629,16.794 L13.5002629,14.147 L8.85426293,18.794 L8.14626293,18.086 L13.1462629,13.086 C13.3422629,12.891 13.6582629,12.891 13.8542629,13.086 L16.5002629,15.733 L22.2932629,9.94 L19.0002629,9.94 L19.0002629,8.94 L23.5002629,8.94 C23.7762629,8.94 24.0002629,9.164 24.0002629,9.44 L24.0002629,9.44 Z M26.8622629,25.94 L5.32526293,25.94 L3.60926293,23.94 L28.4462629,23.94 L26.8622629,25.94 Z M5.00026293,7.01 C5.00026293,6.453 5.45326293,5.94 6.01026293,5.94 L25.9902629,5.94 C26.5472629,5.94 27.0002629,6.453 27.0002629,7.01 L27.0002629,22.94 L5.00026293,22.94 L5.00026293,7.01 Z M29.9522629,23.286 C29.8692629,23.111 29.6932629,23 29.5002629,23 L28.0002629,23 L28.0002629,7.01 C28.0002629,5.901 27.0992629,5 25.9902629,5 L6.01026293,5 C4.90126293,5 4.00026293,5.901 4.00026293,7.01 L4.00026293,23 L2.50026293,23 C2.30426293,23 2.12526293,23.115 2.04426293,23.294 C1.96326293,23.474 1.99526293,23.684 2.12526293,23.831 L4.72526293,26.771 C4.82026293,26.878 4.95626293,26.94 5.10026293,26.94 L27.1002629,26.94 C27.2502629,26.94 27.3922629,26.873 27.4872629,26.756 L29.8882629,23.816 C30.0102629,23.667 30.0342629,23.46 29.9522629,23.286 L29.9522629,23.286 Z",
    id: "Analytics_Category-Icon_32_Squid-"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryAnalytics32);
export default __webpack_public_path__ + "static/media/Arch-Category_Analytics_32.09e2715495ff4a993319cfb536b4b082.svg";
export { ForwardRef as ReactComponent };